import {Component, Inject, OnInit} from '@angular/core';
import {ThresholdDictionary} from "../../../../shared/interface/threshold-dictionary";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {InsuranceCompany} from "../../../../shared/interface/insurance-company";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ThresholdService} from "../../../../shared/services/threshold.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Dictionary} from "../../../../shared/interface/dictionary";
import {catchError, mapTo, tap} from "rxjs/operators";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {of} from "rxjs";
import {RiskDictionary} from "../../../../shared/interface/risk-dictionary";
import {RiskDictionaryService} from "../../../../shared/services/risk-dictionary.service";

export interface EditRiskDictionaryModalData {
  riskDictionary: RiskDictionary;
}

@Component({
  selector: 'app-edit-risk-dict-modal',
  templateUrl: './edit-risk-dict-modal.component.html',
  styleUrls: ['./edit-risk-dict-modal.component.scss']
})
export class EditRiskDictModalComponent implements OnInit {

  riskDictionaryObject: RiskDictionary;
  riskDictionaryForm: FormGroup;
  insuranceCompanyControl: FormControl;
  policyTypesControl: FormControl;
  nameControl: FormControl;
  processingRequest = false;
  selectedInsuranceCompany: InsuranceCompany;

  constructor(
    public dialogRef: MatDialogRef<EditRiskDictModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditRiskDictionaryModalData,
    private fb: FormBuilder,
    private riskDictionaryService: RiskDictionaryService,
    private snack: MatSnackBar,
  ) {
    this.riskDictionaryObject = data.riskDictionary;
    this.selectedInsuranceCompany = data.riskDictionary.insuranceCompany;
    this.riskDictionaryForm = fb.group({
      name: this.nameControl = fb.control('', [Validators.required]),
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      policyTypes: this.policyTypesControl = fb.control([]),
    });
  }

  ngOnInit(): void {
    this.riskDictionaryForm.setValue({
      name: this.riskDictionaryObject?.name ?? '',
      insuranceCompany: this.riskDictionaryObject?.insuranceCompany?.id ?? '',
      policyTypes: this.riskDictionaryObject?.policyTypes?.map((policyType: Dictionary) => policyType.id) ?? [],
    });
  }

  save(): void {
    this.processingRequest = true;
    this.riskDictionaryService
      .sendForm(this.riskDictionaryForm.value, this.riskDictionaryObject.uuid)
      .pipe(
        tap(() => this.processingRequest = false),
        tap((response: Uuid) => this.dialogRef.close(response.uuid)),
        mapTo('Pomyślnie zaktualizowano słownik'),
        catchError(() => {
          this.processingRequest = false;
          return of('Podczas przesyłania formularza wystąpił błąd');
        })
      )
      .subscribe((message: string) => {
        this.snack.open(message, '', {
          duration: 2000,
        });
      });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  insuranceCompanyChanged(insuranceCompany: InsuranceCompany): void {
    this.selectedInsuranceCompany = insuranceCompany;
  }
}
